import { createSlice } from '@reduxjs/toolkit';

// ----------------------------------------------------------------------

const initialState = {
  selectedGameTab: '',
};

const slice = createSlice({
  name: 'gameTab',
  initialState,
  reducers: {
    setSelectedGameTab(state, action) {
      state.selectedGameTab = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { setSelectedGameTab } = slice.actions;
